import apiClient from '../../../Services/ApiClient';
import { ECardNewFileSelectedItem } from '../Components/ECardNewFilesList/ECardNewFilesListWrapper';
import { useWorkplacePatientDocumentationFilesMarkAsSeenMutation } from '../../../graphql/graphql';

export default function useECardNewFiles() {
	const [workplacePatientDocumentationFilesMarkAsSeen] =
		useWorkplacePatientDocumentationFilesMarkAsSeenMutation();

	const markAsAllSeen = async () => {
		const result =
			await workplacePatientDocumentationFilesMarkAsSeen().unwrap();
	};

	const markAsSeen = async (items: ECardNewFileSelectedItem[]) => {
		for (const item of items || []) {
			const result = await apiClient.put(
				`/patients/${item.patientId}/documentation/${item.folderId}/${item.id}`,
				{ seen: true },
			);
		}
	};

	const markAsNotSeen = async (item: ECardNewFileSelectedItem) => {
		const result = await apiClient.put(
			`/patients/${item.patientId}/documentation/${item.folderId}/${item.id}`,
			{ seen: false },
		);
	};

	return { markAsSeen, markAsNotSeen, markAsAllSeen };
}
